import Button from '@blocks/Button'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import { route } from '@helpers'
import React from 'react'

export default function SalonUnavailableFinished() {
    const { salon } = useSalonContext()

    return (
        <EmphasizedContent>
            <Grid gap="20px">
                <Grid gap="10px">
                    <h3>You didn't participate in the salon.</h3>
                    <p>You can check public results on the landing.</p>
                </Grid>
                <Flex justifyContent="flex-start">
                    <Button width="auto" to={route("general:salon", salon.state.slug)} element="a" target="_blank">
                        Check Results
                    </Button>
                </Flex>
            </Grid>
        </EmphasizedContent>
    )
}